import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UtilService } from '../services/util.service';
import { Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const utilService = inject(UtilService);
  const router = inject(Router);

  const user = authService.getUser();
  if (!user) {
    utilService.navigate('/');
    return false;
  } else {
    return true;
  }
};